export function Footer() {
  return (
    <footer className="mt-12 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-slate-500">
        <div>
          © {new Date().getFullYear()} RedesIP CRM
        </div>
        <div className="flex items-center gap-4">
          <a
            href="https://redesip.org"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-600 hover:text-slate-900 font-medium"
          >
            redesip.org
          </a>
          <a
            href="https://redesip.org/soporte"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-slate-700"
          >
            Soporte
          </a>
        </div>
      </div>
    </footer>
  );
}
